const kashika1Options = [
    {
        menuName: "水害リスク情報（河川）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label : "河川浸水想定区域図\n（想定最大規模）",
                type: "vector",
                dataset_id: 1,
                id: "kasen-saidai",
                url:process.env.REACT_APP_LAYER_64_2_KASEN_SHINSUI_MAX,
                layerName:"64_2_shinsui_souteisaidai",
                color:"orangered",
                opacity: 0.7
            },
            {
                label : "河川浸水継続時間\n（想定最大規模）",
                type: "vector",
                dataset_id: 2,
                id: "kasen-keizoku",
                url:process.env.REACT_APP_LAYER_64_3_KASEN_SHINSUI_TIME,
                layerName:"64_3_shinsui_keizokuzikan",
                color:"tomato",
                opacity: 0.7
            },
        ]
    },
    {
        menuName: "水害リスク情報（高潮・津波）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "高潮浸水想定図\n（想定最大規模）",
                type: "vector",
                dataset_id: 6,
                id: "takashio-saidai",
                url:process.env.REACT_APP_LAYER_70_3_TAKASHIO_KEIKAKU,
                layerName:"70_3_takashio_max",
                color:"steelblue",
                opacity: 0.7
            },
            {
                label: "津波浸水想定図",
                type: "vector",
                dataset_id: 7,
                id: "tsunami",
                url:process.env.REACT_APP_TSUNAMI,
                layerName:"71_tsusnami_shinsui",
                color:"cyan",
                opacity: 0.7
            },
            {
                label: "津波災害警戒区域図",
                type: "vector",
                dataset_id: 8,
                id: "tsunami-saigai",
                url:process.env.REACT_APP_TSUNAMI_SAIGAI,
                layerName:"72_tsunami_keikai",
                color:"#ffffb3",
                opacity: 0.7,
                legendColorClass: "h-tsunami-saigai",
            },
        ]
    },
    {
        menuName: "土砂災害リスク情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "土砂災害警戒区域_土石流",
                type: "vector",
                dataset_id: 9,
                id: "tosha_73_1",
                url:process.env.REACT_APP_LAYER_73_1,
                layerName: "73_dosekiryu_keikai",
                color:"#fffe9b",
                borderColor:"#1072bd",
                border: '1px solid blue',
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-dosekiryu"
            },
            {
                label: "土砂災害警戒区域_地すべり",
                type: "vector",
                dataset_id: 11,
                id: "tosha_73_3",
                url:process.env.REACT_APP_LAYER_73_3,
                layerName: "73_jisuberi_keikai",
                color:"#fffe9b",
                borderColor:"#eb7d3c",
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-jisuberi"
            },
            {
                label: "土砂災害警戒区域_がけ崩れ",
                type: "vector",
                dataset_id: 12,
                id: "tosha_73_4",
                url:process.env.REACT_APP_LAYER_73_4,
                layerName: "73_kyukeisya_keikai",
                color:"#fffe9b",
                borderColor:"#72ac4d",
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-gake"
            },
            {
                label: "土砂災害特別警戒区域_土石流",
                type: "vector",
                dataset_id: 10,
                id: "tosha_73_2",
                url:process.env.REACT_APP_LAYER_73_2,
                layerName: "73_dosekiryu_tokubetsukeikai",
                color:"#fe868d",
                borderColor:"#fc0d1b",
                opacity: 0.7,
                legendColorClass: "h-dosha-dstk-dosekiryu"
            },
            {
                label: "土砂災害特別警戒区域_がけ崩れ",
                type: "vector",
                dataset_id: 13,
                id: "73_kyukeisya_tokubetsukeikai",
                url:process.env.REACT_APP_LAYER_73_5,
                layerName: "73_kyukeisya_tokubetsukeikai",
                color:"#fe868d",
                borderColor:"#fc3dca",
                opacity: 0.7,
                legendColorClass: "h-dosha-dstk-gake"
            },

            {
                label: "雪崩危険箇所_雪崩",
                type: "vector",
                dataset_id: 15,
                id: "nadare",
                url:process.env.REACT_APP_NADARE,
                layerName:"74_nadare",
                color:"#b8d5a6",
                borderColor:"#1db1ed",
                opacity: 0.7,
                legendColorClass: "h-dosha-nadare"
            },
        ]
    },
  
    // {
    //     menuName: "土砂災害危険度情報",
    //     activateAccordion: false,
    //     useAccordion: true,
    //     options: [
    //
    //         {
    //             // # 63_1: 河川管理情報システム (河川防災情報システム)	土砂災害危険度情報	土砂災害危険度テキストデータ　1kmメッシュ
    //             label: "土砂災害危険度_1kmメッシュ",
    //             type: "vector",
    //             id: "vis_63_1",
    //             url:process.env.REACT_APP_63_1_TILE,
    //             dataUrl:process.env.REACT_APP_63_1_DATA,
    //             layerName:"mesh_1km",
    //         },
    //     ]
    // },
  
    // {
    //     menuName: "地震リスク情報",
    //     activateAccordion: false,
    //     useAccordion: true,
    //     options : [
    //         {
    //             // 91: 地震被害想定図
    //             label: "地震被害想定図",
    //             type: "vector",
    //             id: "vis_91",
    //             url:process.env.REACT_APP_LAYER_91,
    //             layerName:"earthquake_nankai",
    //         },
    //     ]
    // },
    
    {
        menuName: "ため池情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "ため池ポイント",
                type: "marker",
                dataset_id: 20,
                id: "tameike",
                url:process.env.REACT_APP_TAMEIKE
            },
            {
                label: "ため池浸水想定区域",
                type: "vector",
                dataset_id: 21,
                id: "shinsui",
                url:process.env.REACT_APP_LAYER_80_TAMEIKE_SHINSUI,
                layerName:"80_tameike_shinsui",
                color:"#6373e6",
                opacity: 0.7,
                legendColorClass: "h-tameike"
            },
        ]
    },
    {
        menuName: "避難所情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "避難所情報",
                type: "marker",
                dataset_id: 3,
                id: "hinanjo",
                url:process.env.REACT_APP_HINANJO
            },
        ]
    },

    {
        menuName: "過去に発生した災害の記録",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "災害の記録",
                type: "marker",
                id: "vis_66",
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_SPOT_66,
            },
        ]
    },
  
    {
        menuName: "道路に関する情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "本日の規制",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_1",
                url:process.env.REACT_APP_DOROKISEI_1
            },
            {
                label: "今後の規制",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_2",
                url:process.env.REACT_APP_DOROKISEI_2
            },
            {
                label: "事前通行規制区間",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_3",
                url:process.env.REACT_APP_DOROKISEI_3
            },
            {
                label: "走行注意区間",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_4",
                url:process.env.REACT_APP_DOROKISEI_4
            },
            {
                label: "緊急輸送道路",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_5",
                url:process.env.REACT_APP_DOROKISEI_5
            },  
            {
                label: "道路カメラ・冬季道路情報",
                type: "marker",
                dataset_id: 3,
                id: "sekisetusin_6_10",
                url:process.env.REACT_APP_SEKISETUSIN_6_10
            },
        ]
    },

    {
        menuName: "インフラ情報（河川）",
        activateAccordion: false,
        useAccordion: true,
        options: [

            {
                // # 22: 河川管理情報システム（河川AMS）	排水機場管理（河川）_詳細情報
                label: "排水機場（河川）",
                type: "marker",
                id: "vis_22",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_22,
            },

            {
                // # 19: 河川管理情報システム（河川AMS）	河川トンネル管理_詳細情報 マーカーは(上流端の座標を使用)
                label: "河川トンネル",
                type: "marker",
                id: "vis_19",
                column_lat: "上流端　緯度(10進数)",
                column_lng: "上流端　経度(10進数)",
                url:process.env.REACT_APP_SPOT_19,
            },

            {
                // # 21: 河川管理情報システム（河川AMS）	調節池管理_詳細情報
                label: "調整池",
                type: "marker",
                id: "vis_21",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_21,
            },

            {
                // # 20: 河川管理情報システム（河川AMS）	地下調節池管理_詳細情報
                label: "地下調整池",
                type: "marker",
                id: "vis_20",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_20,
            },

        ]},

  
    {
        menuName: "インフラ情報（砂防）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "砂防堰堤",
                type: "marker",
                dataset_id: 3,
                id: "sabo_25",
                url:process.env.REACT_APP_SABO_25
            },

            {
                // 78_2 広島県砂防GIS管理システム	GIS情報	砂防設備・急傾斜地崩壊対策施設　砂防設備台帳_渓流保全工ライン
                label: "渓流保全工",
                type: "vector",
                id: "vis_78_2",
                color:"#06ACFF",
                borderColor: "#06ACFF",
                layerName:"78_051shp_keiryu_line",
                legendColorClass: "h-dosha-dskid-keiryuhozen",
                url:process.env.REACT_APP_LAYER_78_2,
            },
            {
                // 78_3 広島県砂防GIS管理システム	GIS情報	砂防設備・急傾斜地崩壊対策施設　急傾斜地崩壊対策施設
                label: "急傾斜地崩壊防止施設",
                type: "marker",
                id: "vis_78_3",
                menuIcon: true,
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_LAYER_78_3,
            },
            {
                // 78_4 広島県砂防GIS管理システム	GIS情報	砂防設備・急傾斜地崩壊対策施設　地すべり対策施設
                label: "地すべり防止施設",
                type: "vector",
                id: "vis_78_4",
                color:"#CDCD66",
                borderColor: "#6D6D00",
                layerName:"78_053_jisuberi_shisetsu",
                legendColorClass: "h-dosha-jb-jisuberi-shisetsu",
                url:process.env.REACT_APP_LAYER_78_4,
            },
        ]
    },
  
    {
        menuName: "インフラ情報（海岸）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "防潮扉（水門・陸閘）",
                type: "marker",
                dataset_id: 3,
                id: "suimon_29",
                url:process.env.REACT_APP_SUIMON_29
            },
            {
                label: "海岸保全施設",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_4",
                url:process.env.REACT_APP_KOUWAN_30_4
            },
            {
                // # 18: 河川管理情報システム（河川AMS）	排水機場管理（港湾）_詳細情報
                label: "排水機場（港湾海岸）",
                type: "marker",
                id: "vis_18",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_18,
            },

        ]
    },
    {
        menuName: "非常用電話位置情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "非常用電話位置情報",
                type: "marker",
                id: "vis_95",
                column_lat: "緯度　世界",
                column_lng: "経度　世界",
                url:process.env.REACT_APP_SPOT_95
            },
        ]
    },




];

export  {
    kashika1Options
};
